<template>
    <div class="purchase_component_wrap" v-loading="loading">
        <el-tabs v-model="tabActiveName" @tab-click="handleClickTab">
            <el-tab-pane label="待付款" name="1">
                <span slot="label">
                    <span>待付款</span>
                    <el-badge :value="pendingCount > 99 ? '99+' : pendingCount" v-if="pendingCount>0" size="mini"></el-badge>
                </span>
            </el-tab-pane>
            <el-tab-pane label="已付款" name="2"> </el-tab-pane>
            <el-tab-pane label="已取消" name="3"> </el-tab-pane>
        </el-tabs>
        <div class="content_right_wrap">
            <div class="page-filter_wrap">
                <div class="page-filter_wrap_left">
                    <el-input
                        v-model="searchForm.keyword"
                        class="filter-input"
                        clearable
                        placeholder="请输入您想搜索的内容"
                        @clear="handleClickSearch"
                        @keyup.enter.native="handleClickSearch"
                    >
                        <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                    </el-input>
                    <el-popover placement="bottom-start" width="520" trigger="click">
                        <div class="search_container">
                            <div class="search_top_container">
                                <span class="title">筛选</span>
                                <el-button
                                    @click="handleClickReset"
                                    size="mini"
                                    :disabled="
                                        searchFilterList.findIndex((find) => find.field_value) > -1 ? false : true
                                    "
                                    >清空筛选条件</el-button
                                >
                            </div>
                            <div class="search_bottom_container">
                                <ul>
                                    <li v-for="item in searchFilterList">
                                        <div>
                                            <el-select size="small" v-model="item.field_key" disabled>
                                                <el-option label="申请人" value="uid"></el-option>
                                                <el-option label="创建时间" value="apply_time_range"></el-option>
                                                <el-option label="付款状态" value="filter_payment_status"></el-option>
                                                <el-option label="退款类型" value="return_type"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="search_filter_type">
                                            <el-select size="small" v-model="item.field_type" disabled>
                                                <el-option label="满足" value="eq"></el-option>
                                                <el-option label="不满足" value="neq"></el-option>
                                            </el-select>
                                        </div>
                                        <div>
                                            <template v-if="item.field_key == 'uid'">
                                                <el-select
                                                    v-model="item.field_value"
                                                    placeholder="请选择申请人"
                                                    :remote-method="getUserList"
                                                    filterable
                                                    remote
                                                    clearable
                                                    size="small"
                                                    @change="handleClickSearch"
                                                >
                                                    <el-option
                                                        v-for="user in userOptions"
                                                        :key="user.uid"
                                                        :label="user.name"
                                                        :value="user.uid"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </template>
                                            <template v-if="item.field_key == 'apply_time_range'">
                                                <el-date-picker
                                                    v-model="item.field_value"
                                                    :editable="false"
                                                    end-placeholder="结束时间"
                                                    format="yyyy-MM-dd"
                                                    range-separator="～"
                                                    size="small"
                                                    start-placeholder="开始时间"
                                                    type="daterange"
                                                    value-format="yyyy-MM-dd"
                                                    @clear="item.field_value = []"
                                                    @change="handleClickSearch"
                                                >
                                                </el-date-picker>
                                            </template>
                                            <template v-if="item.field_key == 'filter_payment_status'">
                                                <el-select
                                                    v-model="item.field_value"
                                                    placeholder="请选择付款状态"
                                                    size="small"
                                                    @change="handleClickSearch"
                                                    clearable
                                                >
                                                    <el-option
                                                        v-for="user in paymentStatusOptions[tabActiveName]"
                                                        :key="user.value"
                                                        :label="user.label"
                                                        :value="user.value"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </template>
                                            <template v-if="item.field_key == 'return_type'">
                                                <el-select
                                                    v-model="item.field_value"
                                                    placeholder="请选择退款类型"
                                                    size="small"
                                                    @change="handleClickSearch"
                                                    clearable
                                                >
                                                    <el-option
                                                        v-for="user in returnTypeOptions"
                                                        :key="user.value"
                                                        :label="user.label"
                                                        :value="user.value"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </template>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <el-button size="small" slot="reference" class="custom_popover_button">
                            <i class="iconfont icon-shaixuan"></i>
                            <span
                                class="search_filter_length"
                                v-if="searchFilterList.filter((find) => find.field_value).length"
                            >
                                <span
                                    v-text="searchFilterList.filter((find) => find.field_value).length + '个条件'"
                                ></span>
                                <i class="el-icon-error" @click="handleClickReset"></i>
                            </span>
                        </el-button>
                    </el-popover>
                </div>
                <div class="page-filter_wrap_right" v-if="hasOperatePermission">
                    <el-button type="primary" plain @click="handleClickExport">导出</el-button>
                    <el-button type="primary" plain v-if="tabActiveName == 1" @click="handleClickBatchCancel"
                        >批量取消</el-button
                    >
                    <el-button type="primary" v-if="tabActiveName == 1" @click="handleClickBatchPayment"
                        >批量付款</el-button
                    >
                </div>
            </div>
            <div class="page-content">
                <CustomVxeTable
                    :id="getRandomId(1, 100)"
                    :ref="'tableRef' + tabActiveName"
                    :customConfig="tableCustomConfig"
                    :empty-render="{ name: 'NotData' }"
                    :isShowToolBar="true"
                    :pagination.sync="pagination"
                    :reduceHeight="reduceHeight"
                    :tableData="tableData"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                    @selection-change="selectionChange"
                >
                    <vxe-column fixed="left" type="checkbox" width="42"></vxe-column>
                    <vxe-column field="payable_no" title="应付编号" fixed="left" min-width="158" show-overflow>
                        <template #default="{ row }">
                            <span class="link-label" @click="handleClickPayableDetail(row)">{{ row.payable_no }}</span>
                        </template>
                    </vxe-column>
                    <vxe-column
                        field="supplier_name"
                        title="供应商名称"
                        min-width="164"
                        show-overflow
                        v-if="payable_type === 'purchase'"
                        key="1"
                    >
                        <template #default="{ row }">
                            <span>{{ row.detail && row.detail.supplier_name }}</span>
                        </template>
                    </vxe-column>
                    <vxe-column
                        field="purchase_purchase_no"
                        title="采购编号"
                        min-width="160"
                        show-overflow
                        v-if="payable_type === 'purchase'"
                        key="2"
                    >
                        <template #default="{ row }">
                            <span class="link-label" @click="handleClickRelateId(row.relate_id)">{{
                                row.detail && row.detail.purchase_no
                            }}</span>
                        </template>
                    </vxe-column>
                    <vxe-column
                        field="customer_company_name"
                        title="客户公司名称"
                        min-width="164"
                        show-overflow
                        v-if="payable_type === 'order_return'"
                        key="3"
                    >
                        <template #default="{ row }">
                            <span
                                class="link-label"
                                @click="
                                    handleClickCustomerDetail(
                                        row.customer_info && row.customer_info.id,
                                        row.customer_info && row.customer_info.name
                                    )
                                "
                                >{{ row.customer_info && row.customer_info.name }}</span
                            >
                        </template>
                    </vxe-column>
                    <vxe-column
                        field="order_no"
                        title="订单编号"
                        min-width="160"
                        show-overflow
                        v-if="payable_type === 'order_return'"
                        key="4"
                    >
                        <template #default="{ row }">
                            <span
                                class="link-label"
                                @click="handleClickOrderDetail(row.detail && row.detail.order_no)"
                                >{{ row.detail && row.detail.order_no }}</span
                            >
                        </template>
                    </vxe-column>

                    <vxe-column
                        field="payee_name"
                        title="收款方"
                        min-width="160"
                        show-overflow
                        v-if="payable_type !== 'purchase' && payable_type !== 'order_return'"
                        key="5"
                    >
                        <template #default="{ row }">
                            <span>{{ row.detail && row.detail.payee_name }}</span>
                        </template>
                    </vxe-column>

                    <vxe-column field="approval_number" title="审批编号" min-width="102" show-overflow>
                        <template #default="{ row }">
                            <span
                                v-if="row.approval_id"
                                class="link-label"
                                @click="handleClickApprovalDetail(row.approval_id)"
                                >{{ row.approval_id }}</span
                            >
                            <span v-else>--</span>
                        </template>
                    </vxe-column>
                    <vxe-column field="return_type_name" title="退款类型" width="120" v-if="payable_type == 'order_return'" key="14">
                        <template #default="{ row }">
                            <span>{{ row.return_type_name || '--' }}</span>
                        </template>
                    </vxe-column>
                    <vxe-column field="user_name" title="申请人" width="120">
                        <template #default="{ row }">
                            <PersonnelCard :userId="row.uid_info.id" v-if="row.uid_info && row.uid_info.id">
                                <template slot="container">
                                    <div class="user-avatar-btn">
                                        <img :src="row.uid_info.avatar ? row.uid_info.avatar : defaultImg" alt="" />
                                        <span>{{ row.uid_info.name }}</span>
                                    </div>
                                </template>
                            </PersonnelCard>
                        </template>
                    </vxe-column>
                    <vxe-column
                        field="created_at"
                        :title="tabActiveName == 1 ? '创建时间' : tabActiveName == 2 ? '支付时间' : '取消时间'"
                        min-width="178"
                        show-overflow
                        key="6"
                    >
                        <template #default="{ row }">
                            <span v-if="tabActiveName == 1">{{ row.created_at }}</span>
                            <span v-else-if="tabActiveName == 2">{{ row.payment_time }}</span>
                            <span v-else>{{ row.cancel_time }}</span>
                        </template>
                    </vxe-column>
                    <vxe-column
                        field="payment_status"
                        title="付款状态"
                        min-width="90"
                        v-if="tabActiveName == 1 || tabActiveName == 2"
                        key="7"
                    >
                        <template #default="{ row }">
                            <span class="pay_status pay_status1" v-if="row.payment_status == 1">待付款</span>
                            <span class="pay_status pay_status2" v-else-if="row.payment_status == 2">已付款</span>
                            <span class="pay_status pay_status4" v-else-if="row.payment_status == 4">部分付款</span>
                        </template>
                    </vxe-column>
                    <template v-if="tabActiveName === '1' || tabActiveName === '2'">
                        <vxe-column
                            header-align="right"
                            align="right"
                            field="payable_amount"
                            title="应付金额"
                            width="150"
                            key="8"
                        >
                            <template #default="{ row }">
                                <span
                                    v-text="
                                        Number(row.payable_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                                <template
                                    v-if="
                                        row.op_payment_type &&
                                        (row.op_payment_type == 'whole' ||
                                            row.op_payment_type == 'part' ||
                                            row.op_payment_type == 'none')
                                    "
                                >
                                    <el-tooltip
                                        :content="row.op_payment_type_name + '(' + row.op_payment_amount + '元)'"
                                        effect="dark"
                                        placement="bottom"
                                    >
                                        <span class="handle_icon_wrap whole_icon" v-if="row.op_payment_type == 'whole'"
                                            ><i class="iconfont icon-lijizhifu"></i
                                        ></span>
                                        <span
                                            class="handle_icon_wrap part_icon"
                                            v-else-if="row.op_payment_type == 'part'"
                                            ><i class="iconfont icon-bufenzhifu"></i
                                        ></span>
                                        <span class="handle_icon_wrap none_icon" v-else
                                            ><i class="iconfont icon-zanbuzhifu"></i
                                        ></span>
                                    </el-tooltip>
                                </template>
                            </template>
                        </vxe-column>
                        <vxe-column
                            header-align="right"
                            align="right"
                            field="paid_amount"
                            title="已付金额"
                            min-width="140"
                            show-overflow
                            key="13"
                            v-if="tabActiveName === '2'"
                        >
                            <template #default="{ row }">
                                <span
                                    v-text="
                                        Number(row.paid_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                            </template>
                        </vxe-column>
                        <vxe-column
                            header-align="right"
                            align="right"
                            field="unpaid_amount"
                            title="未付金额"
                            min-width="140"
                            show-overflow
                            key="9"
                        >
                            <template #default="{ row }">
                                <span
                                    v-text="
                                        Number(row.unpaid_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                            </template>
                        </vxe-column>
                    </template>
                    <template v-if="tabActiveName === '3'">
                        <vxe-column
                            header-align="right"
                            align="right"
                            field="payable_amount"
                            title="应付金额"
                            width="150"
                            key="10"
                        >
                            <template #default="{ row }">
                                <span
                                    v-text="
                                        Number(row.payable_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                                <template
                                    v-if="
                                        row.op_payment_type &&
                                        (row.op_payment_type == 'whole' ||
                                            row.op_payment_type == 'part' ||
                                            row.op_payment_type == 'none')
                                    "
                                >
                                    <el-tooltip
                                        :content="row.op_payment_type_name + '(' + row.op_payment_amount + '元)'"
                                        effect="dark"
                                        placement="bottom"
                                    >
                                        <span class="handle_icon_wrap whole_icon" v-if="row.op_payment_type == 'whole'"
                                            ><i class="iconfont icon-lijizhifu"></i
                                        ></span>
                                        <span
                                            class="handle_icon_wrap part_icon"
                                            v-else-if="row.op_payment_type == 'part'"
                                            ><i class="iconfont icon-bufenzhifu"></i
                                        ></span>
                                        <span class="handle_icon_wrap none_icon" v-else
                                            ><i class="iconfont icon-zanbuzhifu"></i
                                        ></span>
                                    </el-tooltip>
                                </template>
                            </template>
                        </vxe-column>
                        <vxe-column
                            header-align="right"
                            align="right"
                            field="paid_amount"
                            title="已付金额"
                            min-width="116"
                            show-overflow
                            key="11"
                        >
                            <template #default="{ row }">
                                <span
                                    v-text="
                                        Number(row.paid_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                            </template>
                        </vxe-column>
                        <vxe-column
                            header-align="right"
                            align="right"
                            field="cancel_amount"
                            title="取消付款金额"
                            min-width="116"
                            show-overflow
                            key="12"
                        >
                            <template #default="{ row }">
                                <span
                                    v-text="
                                        Number(row.unpaid_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                            </template>
                        </vxe-column>
                    </template>
                    <vxe-column field="bank_name" title="开户行" min-width="276" show-overflow>
                        <template #default="{ row }">
                            <span>{{ row.bank_name }}</span>
                        </template>
                    </vxe-column>
                    <vxe-column field="account_name" title="开户名" min-width="240" show-overflow>
                        <template #default="{ row }">
                            <span>{{ row.account_name }}</span>
                        </template>
                    </vxe-column>
                    <vxe-column field="account_number" title="开户账号" min-width="180" show-overflow>
                        <template #default="{ row }">
                            <span>{{ row.account_number }}</span>
                        </template>
                    </vxe-column>
                    <vxe-column field="operate" width="90" fixed="right">
                        <template #header>
                            <span>操作</span>
                            <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                                <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>
                            </el-tooltip>
                        </template>
                        <template #default="{ row }">
                            <el-dropdown placement="bottom-end" trigger="click">
                                <el-tooltip effect="dark" content="更多" placement="top"
                                    ><i class="iconfont el-icon-more cursor"></i
                                ></el-tooltip>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item
                                        @click.native="handleClickPayablePayment(row)"
                                        v-if="(row.payment_status == 1 || row.payment_status == 4) && hasOperatePermission"
                                    >
                                        付款
                                    </el-dropdown-item>
                                    <el-dropdown-item
                                        @click.native="handleClickPayablePaymentCancel(row)"
                                        v-if="(row.payment_status == 1 || row.payment_status == 4) && hasOperatePermission"
                                    >
                                        取消付款
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClickPayableDetail(row)">
                                        详情
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </vxe-column>
                    <template #empty>
                        <div class="custom-table-empty">
                            <div class="custom-table-empty-img"></div>
                            <p class="custom-table-empty-txt">暂无数据</p>
                        </div>
                    </template>
                </CustomVxeTable>
            </div>
        </div>
        <!-- 付款 -->
        <PayablePaymentDialog
            v-if="payablePaymentDialog"
            :payablePaymentDialog.sync="payablePaymentDialog"
            :payable_no="payable_no"
            :type="payablePaymentType"
            :payable_type="payable_type"
            @paymentSuccess="handleClickSearch"
            @handleAgainLookPayableDetail="handleClickPayableDetail"
        />
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="handleDialogTitle"
            :visible.sync="handleDialogVisible"
            width="520px"
            @close="handleClickCancel"
        >
            <p class="dialog_label_text">{{ handleDialogType === "failPay" ? "付款失败原因" : "取消原因" }}</p>
            <el-input
                :placeholder="handleDialogType === 'failPay' ? '请输入付款失败原因' : '请输入取消原因'"
                :rows="6"
                maxlength="300"
                type="textarea"
                v-model="handleRemarks"
            >
            </el-input>
            <div align="right" slot="footer">
                <el-button @click="handleClickCancel" size="small">取消</el-button>
                <el-button @click="handleClickConfirm" size="small" type="primary">确定</el-button>
            </div>
        </el-dialog>
        <PayableDetailsDialog
            v-if="payableDetailsDialogVisible"
            :payableDetailsDialogVisible.sync="payableDetailsDialogVisible"
            :payable_no="payable_no"
            @handleAgainLookDetail="handleAgainLookDetail"
            @handleDetailToPayment="handleClickPayablePayment"
        />
        <PayableDetailsDialog
            v-if="detailPayableDetailsDialogVisible"
            :payableDetailsDialogVisible.sync="detailPayableDetailsDialogVisible"
            :payable_no="detail_payable_no"
            @handleAgainLookDetail="handleAgainLookDetail"
            @handleDetailToPayment="handleClickPayablePayment"
        />
        <PurchaseDetail
            :purchaseDetailVisible.sync="purchaseDetailVisible"
            v-if="purchaseDetailVisible"
            :purchaseId="purchaseId"
        />
    </div>
</template>
<script>
import { PayableList, PayableCancel, PayableBatchCancel, GetUserList , PayableListExport} from "@/api";
import { pagination } from "@/mixins";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import PayablePaymentDialog from "./component/payable_payment.vue";
import PayableDetailsDialog from "./component/payable_details.vue";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import PurchaseDetail from "../../Purchase/component/purchase_detail.vue"; //采购详情
import * as XLSX from "xlsx";
import {mapGetters} from "vuex";
export default {
    name: "PayableList",
    components: { CustomVxeTable, PayablePaymentDialog, PayableDetailsDialog, PersonnelCard, PurchaseDetail },
    props: {
        payable_type: {
            type: String,
            default: "",
        }, // 采购=purcahse，订单：order_return, 否则就是自定义控件的
        source_id: {
            type: Number,
            default: 0,
        }, // 来源id
    },
    data() {
        return {
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            tabActiveName: "1", // 1待付款, 2已付款, 3已取消 4部分付款， 列表没有4状态
            searchForm: {
                keyword: "",
            },
            tableCustomConfig: {
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return col.column.type !== "checkbox";
                },
                checkMethod: (col) => {
                    return col.column.field !== "payable_no";
                },
                allowSort: true,
            },
            tableData: [],
            pendingCount: 0, // 待付款数量
            selectedList: [],
            // 付款
            payablePaymentDialog: false,
            payablePaymentType: "payment",
            // 取消付款和付款失败
            handleDialogType: "",
            handleDialogTitle: "",
            handleDialogVisible: false,
            handleRemarks: "",
            handleDialogIds: [],
            // 详情
            payableDetailsDialogVisible: false,
            payable_no: "",
            // 筛选条件
            searchFilterList: [
                {
                    field_key: "uid",
                    field_name: "申请人",
                    field_value: "",
                    field_value_name: "",
                    field_type: "eq",
                },
                {
                    field_key: "apply_time_range",
                    field_name: "创建时间",
                    field_value: "",
                    field_value_name: "",
                    field_type: "eq",
                },
                {
                    field_key: "filter_payment_status",
                    field_name: "付款状态",
                    field_value: "",
                    field_value_name: "",
                    field_type: "eq",
                },
                {
                    field_key: "return_type",
                    field_name: "退款类型",
                    field_value: "",
                    field_value_name: "",
                    field_type: "eq",
                },
            ],
            userOptions: [],
            // 支付状态
            paymentStatusOptions: {
                1: [
                    { value: 1, label: "待付款" },
                    { value: 4, label: "部分付款" },
                ],
                2: [
                    { value: 2, label: "已付款" },
                    { value: 4, label: "部分付款" },
                ],
                3: [
                    // { value: 1, label: "待付款" },
                    // { value: 4, label: "部分付款" },
                    { value: 3, label: "已取消" },
                ],
            },

            // 退款类型
            returnTypeOptions: [
                {label: "普通退款", value: "ordinary"},
                {label: "租金退款", value: "rent"},
                {label: "押金退款", value: "deposit"},
                {label: "退货退款", value: "return"},
            ],

            purchaseId: null,
            purchaseDetailVisible: false, //采购详情

            detail_payable_no: "",
            detailPayableDetailsDialogVisible: false
        };
    },
    computed: {
        reduceHeight() {
            return this.pagination.total > 0 ? 215 : 170;
        },
        ...mapGetters(['hasPermission']),
        // 操作权限：付款、确认、取消、驳回、作废等操作；因为后台权限设置的是同一个按钮，所以判断一个权限的类型就行，如果之后权限分开了之后，就需要判断某一个按钮的权限了；目前我这里根据付款的权限判断的
        hasOperatePermission() {
            return this.hasPermission('finance.payable.payment.add', 'finance', 'PayableManage');
        },
    },
    mixins: [pagination],
    watch: {
        source_id(newVal, oldVal) {
            if (newVal) {
                this.tabActiveName = "1";
                this.handleClickTab();
            }
        },
    },
    mounted() {
        if (this.source_id) {
            this.tabActiveName = "1";
            this.getTableData();
        }
        this.getUserList();
    },
    methods: {
        handleClickTab() {
            this.searchForm.keyword = "";
            this.searchFilterList.forEach((item) => {
                this.$set(item, "field_value", "");
            });
            this.selectedList = [];
            this.handleCurrentChange(1);
        },
        getRandomId(min, max) {
            min = Math.ceil(min); // 将min向上取整
            max = Math.floor(max); // 将max向下取整
            return String(Math.floor(Math.random() * (max - min + 1)) + min); // 返回min到max之间的随机整数
        },
        // 搜索
        handleClickSearch() {
            this.pagination.pageNum = 1;
            this.getTableData();
        },
        // 清空筛选条件
        handleClickReset() {
            this.searchFilterList.forEach((item) => {
                this.$set(item, "field_value", "");
            });
            this.handleClickSearch();
        },
        // 表头配置
        handleClickCustom() {
            this.$refs["tableRef" + this.tabActiveName].handleOpenCustomShow();
        },
        // 表格复选框
        selectionChange(ids) {
            this.selectedList = ids;
        },
        getUserList(keyword) {
            GetUserList({ keyword }).then((res) => {
                if (res.code === 200) {
                    this.userOptions = res.data || [];
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 页码改变
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.getTableData();
        },
        // 页数改变
        handleSizeChange(page) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = page.pageSize;
            this.getTableData();
        },
        getTableData() {
            this.loading = true;
            let postData = {
                source_id: this.source_id,
                payment_status: this.tabActiveName,
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
            };
            this.searchFilterList.forEach((item) => {
                if (item.field_value !== "") {
                    postData[item.field_key] = item.field_value;
                }
            });
            PayableList(postData)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = data || [];
                        this.pagination.total = total;
                        if(this.tabActiveName == 1) {
                            this.pendingCount = total
                        }
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 付款
        handleClickPayablePayment(row) {
            this.payablePaymentType = "payment";
            this.payable_no = row.payable_no;
            this.payablePaymentDialog = true;
        },
        // 批量付款
        handleClickBatchPayment() {
            if (!this.selectedList.length) return this.$message.error("请选择需要支付的应付单");
            // if (
            //     !this.selectedList.every((item, index) => {
            //         return index === 0 || item.account_number === this.selectedList[index - 1].account_number;
            //     })
            // )
            //     return this.$message.error("请选择同一开户账号的应付单");
            const payable_no = this.selectedList.map((item) => item.payable_no);
            this.payablePaymentType = "batch_payment";
            this.payable_no = payable_no;
            this.payablePaymentDialog = true;
        },
        // 批量取消
        handleClickBatchCancel() {
            if (!this.selectedList.length) return this.$message.error("请选择需要取消的应付单");
            this.handleDialogVisible = true;
            this.handleDialogTitle = "取消付款";
            this.handleDialogType = "batchCancelPay";
            this.handleDialogIds = this.selectedList.map((item) => item.payable_no);
        },
        // 取消付款
        handleClickPayablePaymentCancel(row) {
            this.handleDialogVisible = true;
            this.handleDialogTitle = "取消付款";
            this.handleDialogType = "cancelPay";
            this.handleDialogIds = [row.payable_no];
        },
        // 弹框取消
        handleClickCancel() {
            this.handleDialogVisible = false;
            this.handleDialogTitle = "";
            this.handleDialogType = "";
            this.handleRemarks = "";
            this.handleDialogIds = [];
        },
        // 弹框确认
        handleClickConfirm() {
            let error_msg = "";
            if (this.handleDialogType === "failPay") {
                error_msg = "请输入付款失败原因";
            } else if (this.handleDialogType === "cancelPay" || this.handleDialogType === "batchCancelPay") {
                error_msg = "请输入取消原因";
            }
            if (!this.handleRemarks) return this.$message.error(error_msg);
            if (this.handleDialogType === "failPay") {
                // 付款失败
            } else {
                // 取消
                if (this.handleDialogType === "cancelPay") {
                    // 单个取消
                    PayableCancel({ payable_no: this.handleDialogIds[0], cancel_reason: this.handleRemarks }).then(
                        (res) => {
                            if (res.code == 200) {
                                this.$message({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.selectedList = [];
                                        this.handleClickSearch();
                                        this.handleClickCancel();
                                    },
                                });
                            } else {
                                this.$message.error(res.message);
                            }
                        }
                    );
                } else {
                    PayableBatchCancel({ payable_nos: this.handleDialogIds, cancel_reason: this.handleRemarks }).then(
                        (res) => {
                            if (res.code == 200) {
                                this.$message({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.selectedList = [];
                                        this.handleClickSearch();
                                        this.handleClickCancel();
                                    },
                                });
                            } else {
                                this.$message.error(res.message);
                            }
                        }
                    );
                }
            }
        },
        // 查看详情
        handleClickPayableDetail(row) {
            this.payable_no = row.payable_no;
            this.payableDetailsDialogVisible = true;
        },
        // 再次查看详情
        handleAgainLookDetail(row){
            if(this.detailPayableDetailsDialogVisible) {
                this.detailPayableDetailsDialogVisible = false
                setTimeout(()=> {
                    this.detail_payable_no = row.payable_no;
                    this.detailPayableDetailsDialogVisible = true;
                })
            } else {
                this.detail_payable_no = row.payable_no;
                this.detailPayableDetailsDialogVisible = true;
            }
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(order_no) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: order_no,
                    name: order_no,
                    query_type: "order_no",
                },
            });
        },
        // 采购详情
        handleClickRelateId(purchaseId) {
            this.purchaseId = purchaseId;
            this.purchaseDetailVisible = true;
        },
        // 审批详情
        handleClickApprovalDetail(approval_id) {
            this.$showApprovalDetail({
                approval_id,
            }).then((res) => {});
        },
        // 导出
        handleClickExport() {
            this.loading = true;
            let postData = {
                source_id: this.source_id,
                payment_status: this.tabActiveName,
                page: 1,
                pageSize: this.pagination.total,
                keyword: this.searchForm.keyword,
            };
            this.searchFilterList.forEach((item) => {
                if (item.field_value !== "") {
                    postData[item.field_key] = item.field_value;
                }
            });
            PayableListExport(postData)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.xlsxToExcel(data);
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        xlsxToExcel(exportData) {
            let tableData = [];
            let fields_list = [];
            const tabActiveName = this.tabActiveName;
            if (this.payable_type == "purchase") {
                // 采购
                fields_list = [
                    { field_key: "payable_no", field_name: "应付编号" },
                    { field_key: "supplier_name", p_Field_key: "detail", field_name: "供应商名称" },
                    { field_key: "purchase_no", p_Field_key: "detail", field_name: "采购编号" },
                ];
            } else if (this.payable_type == "order_return") {
                // 订单
                fields_list = [
                    { field_key: "payable_no", field_name: "应付编号" },
                    { field_key: "name", p_Field_key: "customer_info", field_name: "客户公司名称" },
                    { field_key: "order_no", p_Field_key: "detail", field_name: "订单编号" },
                ];
            } else {
                // 收款方
                fields_list = [
                    { field_key: "payable_no", field_name: "应付编号" },
                    { field_key: "payee_name", p_Field_key: "detail", field_name: "收款方" },
                ];
            }
            fields_list.push({ field_key: "approval_id", field_name: "审批编号" })
            if(this.payable_type == "order_return") {
                // 订单
                fields_list.push({ field_key: "return_type_name", field_name: "退款类型" })
            }
            fields_list = fields_list.concat([
                { field_key: "name", p_Field_key: "uid_info", field_name: "申请人" },
                {
                    field_key: tabActiveName == 1 ? "created_at" : tabActiveName == 2 ? "payment_time" : "cancel_time",
                    field_name: tabActiveName == 1 ? "创建时间" : tabActiveName == 2 ? "支付时间" : "取消时间",
                },
            ]);
            if (tabActiveName == 1 || tabActiveName == 2) {
                fields_list = fields_list.concat([
                    { field_key: "payment_status", field_name: "付款状态" },
                    { field_key: "payable_amount", field_name: "应付金额" },
                ]);
                if (tabActiveName == 2) {
                    fields_list.push({ field_key: "paid_amount", field_name: "已付金额" });
                }
            }
            fields_list.push({ field_key: "unpaid_amount", field_name: "未付金额" });
            if (tabActiveName == 3) {
                fields_list = fields_list.concat([
                    { field_key: "payable_amount", field_name: "应付金额" },
                    { field_key: "paid_amount", field_name: "已付金额" },
                    { field_key: "cancel_amount", field_name: "取消付款金额" },
                ]);
            }
            fields_list = fields_list.concat([
                { field_key: "bank_name", field_name: "开户行" },
                { field_key: "account_name", field_name: "开户名" },
                { field_key: "account_number", field_name: "开户账号" },
            ]);
            tableData = exportData.map((row) => {
                const itemdata = {};
                fields_list.forEach((field) => {
                    if (field.field_key == "payment_status") {
                        itemdata[field.field_name] =
                            row.payment_status == 1
                                ? "待付款"
                                : row.payment_status == 2
                                ? "已付款"
                                : row.payment_status == 4
                                ? "部分付款"
                                : "";
                    } else {
                        itemdata[field.field_name] = field.p_Field_key
                            ? row[field.p_Field_key]?.[field.field_key]
                            : row[field.field_key];
                    }
                });
                return itemdata;
            });
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(tableData);
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            const fileName = this.nowDate();
            XLSX.writeFile(wb, fileName);
        },
        nowDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth() + 1;
            const date = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
            const hours = today.getHours();
            const minutes = today.getMinutes();
            const seconds = today.getSeconds() < 10 ? "0" + today.getSeconds() : today.getSeconds();
            return `${
                this.tabActiveName == 1 ? "待付款" : this.tabActiveName == 2 ? "已付款" : "已取消"
            }应付单-${year}年${month}月${date}日${hours}时${minutes}分${seconds}秒.xlsx`;
        },
    },
};
</script>
<style lang="scss" scoped>
.purchase_component_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .el-tabs {
        ::v-deep {
            .el-tabs__nav {
                margin: 0 16px;
            }
            .el-tabs__header {
                margin: 0;
            }
            .el-tabs__item {
                padding: 0 16px !important;
                height: 48px;
                line-height: 48px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                &.is-active {
                    font-weight: 700;
                    color: rgba(41, 144, 255, 1);
                }
            }
        }
        .el-badge {
            position: absolute;
            right: 0;
            top: -4px;
            font-weight: 400;
            ::v-deep .el-badge__content {
                background: #e44144;
                line-height: 16px;
                height: 16px;
                padding: 0 4px;
                border:none;
            }
        }
    }
    .content_right_wrap {
        flex: 1;
        padding: 16px;
    }
    .pay_status {
        position: relative;
        padding-left: 10px;
        &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -3px;
            width: 6px;
            height: 6px;
            opacity: 1;
            border-radius: 50%;
        }
        &.pay_status1,
        &.pay_status4 {
            &::before {
                background: rgba(240, 120, 50, 0.5);
            }
        }
        &.pay_status2 {
            &::before {
                background: rgba(90, 179, 51, 1);
            }
        }
    }
}
.search_container {
    width: 100%;
    padding: 4px;
    box-sizing: border-box;

    .search_top_container {
        display: flex;
        justify-content: space-between;

        span.title {
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
            font-size: 16px;
            font-weight: bold;
        }

        .el-button {
            padding: 5px 10px;
        }
    }

    .search_bottom_container {
        padding: 16px 0 0px;
        box-sizing: border-box;

        ul {
            width: 100%;

            li {
                width: 100%;
                display: flex;
                margin-bottom: 12px;

                & > div:nth-child(1) {
                    flex: 1;
                }

                .search_filter_type {
                    margin: 0 8px;
                    width: 86px;
                    max-width: 86px;
                }
                & > div:nth-child(3) {
                    width: 234px !important;
                    flex-shrink: 0;
                    & > div {
                        width: 100% !important;
                    }
                }

                .el-date-editor.el-input {
                    width: 100%;
                    display: block;
                }
                .el-date-editor {
                    width: 100% !important;
                    ::v-deep {
                        .el-range-separator {
                            width: 10%;
                            padding: 0;
                        }
                    }
                }
            }
        }
    }
}

.custom_popover_button {
    padding: 8px 8px;
    margin-left: 0px;
    i {
        font-size: 14px;
    }
    .search_filter_length {
        margin-left: 8px;
        i {
            margin-left: 8px;
            color: rgba(173, 173, 173, 1);
        }
    }
}
.dialog_label_text {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 22px;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 4px;
}
.handle_icon_wrap {
    margin-left: 4px;
    vertical-align: top;
}
.whole_icon,
.none_icon {
    i {
        color: rgba(228, 65, 68, 1);
    }
}
.part_icon {
    i {
        color: rgba(41, 144, 255, 1);
    }
}
</style>
